import axiosInstance from "../../configs";
import { getUser } from "../DataUser";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import dayjs from "dayjs";

export async function handleExportExcel({ grandTotalPCE, grandTotalCT, type, showZero }) {
  let fetchedData = [];

  try {
    const user = getUser();
    const params = {};
    if (showZero !== undefined) {
      params.show_zero = showZero ? 1 : 0;
    }

    // Filter di backend untuk user level 7 (Importir)
    if (
      user &&
      (user.id_level === 7 ||
        user.id_user_level === 7 ||
        user.id_level === "7" ||
        user.id_user_level === "7")
    ) {
      params.id_customer = user.username; // username = NPWP
    }

    const res = await axiosInstance.get("/monitoring-stock/export", {
      params,
    });
    fetchedData = res.data || [];
  } catch (e) {
    console.error("load monitoring stock error", e);
    return;
  }

  const wb = XLSX.utils.book_new();
  const usedSheetNames = new Set(["DASHBOARD"]);

  // ============ SHEET 1: DASHBOARD (pivot-style with row grouping) ============
  const dashRows = [];
  const rowOutlines = []; // Track outline level per row
  const dashMerges = [];

  const isDetail = type !== "summary";
  const titleMergeColEnd = isDetail ? 9 : 6;

  // Row 0: Title
  dashRows.push(["PT. PASIFIK LOGISTIK BERIKAT"]);
  rowOutlines.push({});
  dashMerges.push({ s: { r: 0, c: 0 }, e: { r: 0, c: titleMergeColEnd } });

  // Row 1: Subtitle
  dashRows.push([
    isDetail ? "LAPORAN MONITORING STOK - DETAIL" : "LAPORAN MONITORING STOK - SUMMARY",
  ]);
  rowOutlines.push({});
  dashMerges.push({ s: { r: 1, c: 0 }, e: { r: 1, c: titleMergeColEnd } });

  // Row 2: Date
  dashRows.push([
    `Stock Update : ${dayjs().format("DD MMMM YYYY").toUpperCase()}`,
  ]);
  rowOutlines.push({});
  dashMerges.push({ s: { r: 2, c: 0 }, e: { r: 2, c: titleMergeColEnd } });

  // Row 3: empty
  dashRows.push([]);
  rowOutlines.push({});

  // Row 4: Headers
  if (isDetail) {
    dashRows.push([
      "IMPORTIR",
      "KODE BARANG",
      "NAMA BARANG",
      "NILAI KEMASAN",
      "NAMA KEMASAN",
      "NILAI SUBSATUAN",
      "NAMA SUBSATUAN",
      "NILAI SATUAN",
      "NAMA SATUAN",
      "KONVERSI",
    ]);
    rowOutlines.push({});
  } else {
    dashRows.push([
      "IMPORTIR",
      "TOTAL KEMASAN",
      "NAMA KEMASAN",
      "TOTAL SUBSATUAN",
      "NAMA SUBSATUAN",
      "TOTAL SATUAN",
      "NAMA SATUAN",
    ]);
    rowOutlines.push({});
  }

  let currentRowIndex = 5;

  // Data rows for DASHBOARD
  fetchedData.forEach((customer) => {
    const custKms = Number(customer.nilai_kemasan ?? customer.total_ct) || 0;
    const custSub = Number(customer.nilai_subsatuan ?? customer.total_pce) || 0;
    const custSat = Number(customer.nilai_satuan ?? customer.total_liter) || 0;

    if (custKms <= 0 && custSat <= 0 && custSub <= 0) {
      return;
    }

    // Helper formatting helper konversi
    const formatKonversi = (item) => {
      const kms = item.nama_kemasan || item.satuan_kemasan || "CT";
      let sub = item.nama_subsatuan || item.satuan_per_unit || "BO";
      if (sub === "LTR") {
        sub = /\b(CAN|CANS|CANNED|KALENG)\b/i.test(item.item_name || "") ? "CAN" : "BO";
      }
      const isi = Number(item.isi_kemasan) || 1;
      const unit = Number(item.isi_per_unit) || 0;
      if (unit > 0) {
        const ltrPerUnit = unit / 1000;
        const ltrPerKms = Number((isi * ltrPerUnit).toFixed(3));
        return `1 ${kms} = ${isi} ${sub} @ ${unit} ML (${ltrPerKms} LTR)`;
      }
      return `1 ${kms} = ${isi} ${sub}`;
    };

    // Importer summary row
    if (isDetail) {
      dashRows.push([
        customer.nama_customer || "-",
        "",
        "",
        custKms,
        "KEMASAN",
        custSub,
        "SUBSATUAN",
        custSat,
        "SATUAN",
        "",
      ]);
      rowOutlines.push({});
    } else {
      dashRows.push([
        customer.nama_customer || "-",
        custKms,
        "KEMASAN",
        custSub,
        "SUBSATUAN",
        custSat,
        "SATUAN (LTR)",
      ]);
      rowOutlines.push({});
    }
    currentRowIndex++;

    // Item sub-rows
    if (Array.isArray(customer.items)) {
      customer.items.forEach((item) => {
        const itemKms = Number(item.nilai_kemasan ?? item.total_ct) || 0;
        const itemSat = Number(item.nilai_satuan ?? item.total_liter) || 0;
        const itemSub = Number(item.nilai_subsatuan ?? item.total_pce) || 0;

        if (itemKms <= 0 && itemSat <= 0 && itemSub <= 0) {
          return;
        }

        const konvStr = formatKonversi(item);

        if (isDetail) {
          dashRows.push([
            "",
            item.item_code || "-",
            item.item_name || "-",
            itemKms,
            item.nama_kemasan || item.satuan_kemasan || "CT",
            itemSub,
            item.nama_subsatuan || "BO",
            itemSat,
            item.nama_satuan || "LTR",
            konvStr,
          ]);
        } else {
          dashRows.push([
            `    ${item.item_name || item.item_code}`,
            itemKms,
            item.nama_kemasan || item.satuan_kemasan || "CT",
            itemSub,
            item.nama_subsatuan || "BO",
            itemSat,
            item.nama_satuan || "LTR",
          ]);
        }
        rowOutlines.push({ level: 1 });
        currentRowIndex++;
      });
    }
  });

  // Grand Total for DASHBOARD
  const grandKms = fetchedData.reduce(
    (s, c) => s + (Number(c.nilai_kemasan ?? c.total_ct) || 0),
    0
  );
  const grandSub = fetchedData.reduce(
    (s, c) => s + (Number(c.nilai_subsatuan ?? c.total_pce) || 0),
    0
  );
  const grandSat = Number(
    fetchedData
      .reduce((s, c) => s + (Number(c.nilai_satuan ?? c.total_liter) || 0), 0)
      .toFixed(2)
  );

  if (isDetail) {
    dashRows.push([
      "GRAND TOTAL",
      "",
      "",
      grandKms,
      "KEMASAN",
      grandSub,
      "SUBSATUAN",
      grandSat,
      "SATUAN",
      "",
    ]);
    rowOutlines.push({});
  } else {
    dashRows.push([
      "GRAND TOTAL",
      grandKms,
      "KEMASAN",
      grandSub,
      "SUBSATUAN",
      grandSat,
      "SATUAN (LTR)",
    ]);
    rowOutlines.push({});
  }
  currentRowIndex++;

  const wsDash = XLSX.utils.aoa_to_sheet(dashRows);

  // Column widths for DASHBOARD
  if (isDetail) {
    wsDash["!cols"] = [
      { wch: 32 }, // IMPORTIR
      { wch: 16 }, // KODE BARANG
      { wch: 45 }, // NAMA BARANG
      { wch: 15 }, // NILAI KEMASAN
      { wch: 14 }, // NAMA KEMASAN
      { wch: 16 }, // NILAI SUBSATUAN
      { wch: 16 }, // NAMA SUBSATUAN
      { wch: 15 }, // NILAI SATUAN
      { wch: 14 }, // NAMA SATUAN
      { wch: 36 }, // KONVERSI
    ];
  } else {
    wsDash["!cols"] = [
      { wch: 45 }, // IMPORTIR
      { wch: 16 }, // TOTAL KEMASAN
      { wch: 15 }, // NAMA KEMASAN
      { wch: 16 }, // TOTAL SUBSATUAN
      { wch: 16 }, // NAMA SUBSATUAN
      { wch: 16 }, // TOTAL SATUAN
      { wch: 15 }, // NAMA SATUAN
    ];
  }

  // Set row outline levels for collapsible grouping
  wsDash["!rows"] = rowOutlines;
  wsDash["!outline"] = { above: true };
  wsDash["!merges"] = dashMerges;

  XLSX.utils.book_append_sheet(wb, wsDash, "DASHBOARD");

  // ============ INDIVIDUAL IMPORTER SHEETS ============
  fetchedData.forEach((customer) => {
    const custKms = Number(customer.nilai_kemasan ?? customer.total_ct) || 0;
    const custSat = Number(customer.nilai_satuan ?? customer.total_liter) || 0;
    const custSub = Number(customer.nilai_subsatuan ?? customer.total_pce) || 0;

    if (custKms <= 0 && custSat <= 0 && custSub <= 0) {
      return;
    }

    const sheetRows = [];

    // Helper formatting helper konversi
    const formatKonversi = (item) => {
      const kms = item.nama_kemasan || item.satuan_kemasan || "CT";
      let sub = item.nama_subsatuan || item.satuan_per_unit || "BO";
      if (sub === "LTR") {
        sub = /\b(CAN|CANS|CANNED|KALENG)\b/i.test(item.item_name || "") ? "CAN" : "BO";
      }
      const isi = Number(item.isi_kemasan) || 1;
      const unit = Number(item.isi_per_unit) || 0;
      if (unit > 0) {
        const ltrPerUnit = unit / 1000;
        const ltrPerKms = Number((isi * ltrPerUnit).toFixed(3));
        return `1 ${kms} = ${isi} ${sub} @ ${unit} ML (${ltrPerKms} LTR)`;
      }
      return `1 ${kms} = ${isi} ${sub}`;
    };

    // Header info per sheet
    sheetRows.push([customer.nama_customer || "IMPORTIR"]);
    sheetRows.push([
      type === "summary"
        ? "LAPORAN STOK BERJALAN (SUMMARY)"
        : "LAPORAN STOK BERJALAN (DETAIL PER DOKUMEN)",
    ]);
    sheetRows.push([`Stock Update : ${dayjs().format("DD MMMM YYYY HH:mm")}`]);
    sheetRows.push([]); // empty line

    if (type === "summary") {
      // Headers for Summary sheet
      sheetRows.push([
        "NO",
        "KODE BARANG",
        "NAMA BARANG",
        "NILAI KEMASAN",
        "NAMA KEMASAN",
        "NILAI SUBSATUAN",
        "NAMA SUBSATUAN",
        "NILAI SATUAN",
        "NAMA SATUAN",
        "KONVERSI",
      ]);

      let no = 1;
      if (Array.isArray(customer.items)) {
        customer.items.forEach((item) => {
          const itemKms = Number(item.nilai_kemasan ?? item.total_ct) || 0;
          const itemSub = Number(item.nilai_subsatuan ?? item.total_pce) || 0;
          const itemSat = Number(item.nilai_satuan ?? item.total_liter) || 0;

          if (itemKms > 0 || itemSat > 0 || itemSub > 0) {
            sheetRows.push([
              no++,
              item.item_code || "",
              item.item_name || "",
              itemKms,
              item.nama_kemasan || item.satuan_kemasan || "CT",
              itemSub,
              item.nama_subsatuan || "BO",
              itemSat,
              item.nama_satuan || "LTR",
              formatKonversi(item),
            ]);
          }
        });
      }

      // Total row
      sheetRows.push([
        "TOTAL",
        "",
        "",
        custKms,
        "",
        custSub,
        "",
        custSat,
        "",
        "",
      ]);
    } else {
      // Headers for Detail sheet
      sheetRows.push([
        "NO",
        "NOPEN",
        "TANGGAL NOPEN",
        "SERI",
        "LOKASI",
        "MASA TIMBUN",
        "KODE BARANG",
        "NAMA BARANG",
        "NILAI KEMASAN",
        "NAMA KEMASAN",
        "NILAI SUBSATUAN",
        "NAMA SUBSATUAN",
        "NILAI SATUAN",
        "NAMA SATUAN",
        "KONVERSI",
      ]);

      let no = 1;
      if (Array.isArray(customer.items)) {
        customer.items.forEach((item) => {
          if (Array.isArray(item.docs)) {
            item.docs.forEach((doc) => {
              const docKms = Number(doc.nilai_kemasan ?? doc.total_ct) || 0;
              const docSub = Number(doc.nilai_subsatuan ?? doc.total_pce) || 0;
              const docSat = Number(doc.nilai_satuan ?? doc.total_liter) || 0;

              if (docKms > 0 || docSat > 0 || docSub > 0) {
                const docDateStr = doc.tanggal_nopen
                  ? dayjs(doc.tanggal_nopen).format("DD-MM-YYYY")
                  : "-";
                const masaTimbunStr = `${doc.masa_timbun || 0} hari`;

                sheetRows.push([
                  no++,
                  doc.nopen || "",
                  docDateStr,
                  doc.seri || "",
                  doc.lokasi_lot || "",
                  masaTimbunStr,
                  doc.item_code || "",
                  item.item_name || "",
                  docKms,
                  doc.nama_kemasan || item.nama_kemasan || "CT",
                  docSub,
                  doc.nama_subsatuan || item.nama_subsatuan || "BO",
                  docSat,
                  doc.nama_satuan || item.nama_satuan || "LTR",
                  formatKonversi(doc),
                ]);
              }
            });
          }
        });
      }

      // Total row
      sheetRows.push([
        "TOTAL",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        custKms,
        "",
        custSub,
        "",
        custSat,
        "",
        "",
      ]);
    }

    const wsImporter = XLSX.utils.aoa_to_sheet(sheetRows);

    if (type === "summary") {
      wsImporter["!cols"] = [
        { wch: 6 },  // NO
        { wch: 16 }, // KODE BARANG
        { wch: 45 }, // NAMA BARANG
        { wch: 15 }, // NILAI KEMASAN
        { wch: 14 }, // NAMA KEMASAN
        { wch: 16 }, // NILAI SUBSATUAN
        { wch: 16 }, // NAMA SUBSATUAN
        { wch: 15 }, // NILAI SATUAN
        { wch: 14 }, // NAMA SATUAN
        { wch: 36 }, // KONVERSI
      ];
    } else {
      wsImporter["!cols"] = [
        { wch: 6 },  // NO
        { wch: 12 }, // NOPEN
        { wch: 15 }, // TGL NOPEN
        { wch: 8 },  // SERI
        { wch: 12 }, // LOKASI
        { wch: 14 }, // MASA TIMBUN
        { wch: 16 }, // KODE BARANG
        { wch: 45 }, // NAMA BARANG
        { wch: 15 }, // NILAI KEMASAN
        { wch: 14 }, // NAMA KEMASAN
        { wch: 16 }, // NILAI SUBSATUAN
        { wch: 16 }, // NAMA SUBSATUAN
        { wch: 15 }, // NILAI SATUAN
        { wch: 14 }, // NAMA SATUAN
        { wch: 36 }, // KONVERSI
      ];
    }

    // Sanitize sheet name: remove invalid chars, truncate to 31 chars (Excel limit)
    let sheetName = (customer.nama_customer || "Unknown")
      .replace(/[\\\/\?\*\[\]:]/g, "")
      .trim()
      .substring(0, 31);

    // Ensure unique sheet names
    let finalName = sheetName || "IMPORTIR";
    let counter = 1;
    while (usedSheetNames.has(finalName.toUpperCase())) {
      finalName = `${sheetName.substring(0, 27)}_${counter}`;
      counter++;
    }
    usedSheetNames.add(finalName.toUpperCase());

    XLSX.utils.book_append_sheet(wb, wsImporter, finalName);
  });

  const buf = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const blob = new Blob([buf], { type: "application/octet-stream" });
  const fileName =
    type === "summary"
      ? `Monitoring_Stock_Summary_${dayjs().format("YYYYMMDD")}.xlsx`
      : `Monitoring_Stock_Detail_${dayjs().format("YYYYMMDD")}.xlsx`;
  saveAs(blob, fileName);
}
